import React, { FC } from 'react';

type Props = {
  categories: string[];
  vip?: boolean;
};

export const ArtworkCategories: FC<Props> = ({ categories, vip = true }) => (
  <div className='inline-buttons-container--small mb-1'>
    {categories.map((category) => (
      <a
        key={category}
        href={`${Routes.artworks_path()}?tags[]=${category}${!vip ? '&type=op' : ''}`}
        className='tag'
      >
        {category}
      </a>
    ))}
  </div>
);
